<div class="border-card border-0 px-4 py-1 scroll-container" ref="manage_trust_compliance">
    <NavigationBackButton />
    <div class="card-header card-header-secondary shadow rounded-lg mt-2">
      <div class="nav-tabs-navigation">
        <div class="nav-tabs-wrapper">
          <ul class="nav nav-tabs" data-tabs="tabs">
            <li class="rounded-lg me-2 nav-item">
              <a class="text-white text-decoration-none text-x  nav-link" href="#profile" data-toggle="tab">
                Manage An Entity's Compliance
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  <div class="card mt-2 rounded-lg border-0 shadow p-0">
    <div class="quick-tip me-4 ms-4 mt-3 rounded-lg">
      <p class="text-xxs fw-bold">Manage compliance across all your applications</p>
    </div>
    <div class="card-body">
      <div class="p-3">
        <div class="table-responsive border table-border-color rounded-lg p-3 text-xs">
          <table id="compliance_table" class="table table-hover">
            <thead class="custom-header">
              <tr>
                <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Application No</th>
                <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Email</th>
                <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Date Created</th>
                <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Status</th>
                <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in table_data" :key="index">
                <td class="text-xxs text-start">{{ row['Application No'] }}</td>
                <td class="text-xxs text-start">{{ row['Email'] }}</td>
                <td class="text-xxs text-start">{{ row['Date Created'] }}</td>
                <td class="text-xxs text-start">
                  <span class="status-badge" :class="row['Status'].toLowerCase().replace(' ', '-')">
                    {{ row['Status'] }}
                  </span>
                </td>
                <td>
                  <button
                    class="btn btn-secondary-dark btn-sm rounded-small text-xxs shadow text-dark me-2"
                    @click="go_to_pending_compliance_checks(row)"
                  >
                    View
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>